export default {
    map_geofence_geofenceContacts_title: "Alertas para Geocerca: ",
    map_geofence_geofenceContacts_contacts: 'Contactos',
    map_geofence_geofenceContacts_noContacts: 'No se encontraron contactos'
};